module.exports = __webpack_public_path__ + "img/3.7a22bef9.svg";